// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PqB5w{position:relative;overflow:hidden;display:-webkit-box;display:flex;flex-shrink:0;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;width:40px;height:40px;border:solid 2px #fafcfc;border-radius:50%;margin-right:1rem;background-color:#e9e7e5;-webkit-transition:.2s;transition:.2s}.PqB5w+.PqB5w{margin-left:-25px}.PqB5w+.O92EO{margin-left:0}.K22uc{width:24px;height:24px;border:0}.XGTaW{width:25px;height:25px}.gXAO6{width:30px;height:30px}.Q4flV{width:65px;height:65px}.iFg0z{width:90px;height:90px}.eyBXd{width:120px;height:120px}.G5tqV{width:36px;height:36px;margin:0}.G5tqV:first-child:not(:only-child){z-index:1;margin-bottom:-10px}.NHWBO{width:72px;height:72px;margin:0}.NHWBO:first-child{z-index:1;margin-bottom:-15px}.Sz0U4{position:absolute;left:20px;top:50%;margin-top:-15px}.vG8Q6{pointer-events:none}.WZbA9{margin:0}.cqN88{grid-area:avatar;position:sticky;bottom:65px;margin-right:0}.wYNF_{color:#039be5;background-color:#ddeff3}.NALhQ{color:#d961e8;background-color:#fdecff}.llLyk{color:#15c79e;background-color:#d8f8f2}.yBYSB{color:#e83a30;background-color:#ffe0dd}.lFNqe{color:#e3bc0b;background-color:#f9f7d2}.hOHWw{width:70px;height:70px}.XqDVG{height:100%;pointer-events:none}.iP0T7{font-size:20px;font-weight:200;text-transform:uppercase}.XaWa7{font-size:13px}.bf4Rh{font-size:14px}.TWXP4{font-size:17px}.K2QLH{font-size:28px}.xogIH{font-size:35px}.dxrZn{font-size:45px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PqB5w`,
	"root_boat": `O92EO`,
	"root_nav": `K22uc`,
	"root_tiny": `XGTaW`,
	"root_small": `gXAO6`,
	"root_medium": `Q4flV`,
	"root_large": `iFg0z`,
	"root_extraLarge": `eyBXd`,
	"root_event": `G5tqV`,
	"root_bookingInfo": `NHWBO`,
	"root_mobile": `Sz0U4`,
	"root_noInteraction": `vG8Q6`,
	"root_noMargin": `WZbA9`,
	"root_message": `cqN88`,
	"root_blue": `wYNF_`,
	"root_purple": `NALhQ`,
	"root_green": `llLyk`,
	"root_red": `yBYSB`,
	"root_yellow": `lFNqe`,
	"root_instabook": `hOHWw`,
	"image": `XqDVG`,
	"placeholder": `iP0T7`,
	"placeholder_nav": `XaWa7`,
	"placeholder_tiny": `bf4Rh`,
	"placeholder_small": `TWXP4`,
	"placeholder_medium": `K2QLH`,
	"placeholder_large": `xogIH`,
	"placeholder_extraLarge": `dxrZn`
};
module.exports = ___CSS_LOADER_EXPORT___;
